import { CssBaseline, ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material';
import type { PropsWithChildren } from 'react';

export type ThemeProviderProps = PropsWithChildren;

// TODO: Custom theme
const theme = createTheme();

export const ThemeProvider = ({ children }: ThemeProviderProps) => {
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};
